export default __webpack_public_path__ + "static/media/double-dollar-fugue.82bd95bd.png";